import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';

const ComplaintReplySupport = ({
  showFilter = false,
  filterToggle,
  internalStatus,
  applyFilter,
  viewDropdown,
  subIssueDropdown,
  getSubIssueDropdown = [],
  documentUploadUrlPublic,
  documentUrlDataPublic,
  source,
  parentDropdownId
}) => {
  const filterInputs = {
    message: '',
    send_to: '',
    attachment_mand: false,
    attachment_file: '',
    isClosed: false,
    rca: '',
    issue_related_to: '',
    issue_related_to_sub_cat: ''
  };
  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleIssueRelatedToChange = async (val) => {
    if (val?.id) {
      setFilterFieldsData({
        ...filterFieldsData,
        issue_related_to: val.id,
        issue_related_to_sub_cat: '',
      });
    }
  };

  useEffect(() => {
    const parentId = filterFieldsData.issue_related_to;
    if (!parentId || Number(parentId) <= 0) {
      return;
    }
    (async () => {
      setIsLoading(true);
      const status = await subIssueDropdown(parentId);
      setIsLoading(false);
      setListStatus(status);
    })();
  }, [filterFieldsData.issue_related_to, subIssueDropdown]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
      <div className={showFilter ? "show-filter" : ""}>
        {showFilter && (
          <div className="filter-wrapper">
            <div className="filter-heading">
              <h4>Reply</h4>
              <Button onClick={filterToggle} className="close">
                <i className="close"></i>
              </Button>
            </div>
            <div className="filter-body scrollbar-styling">
              <div className="col-sm-12">
                <TextAreaInput
                  name="message"
                  type="text"
                  rows={2}
                  className={`inline-css scrollbar-styling`}
                  label={localization.message}
                  value={filterFieldsData?.message}
                  inputValue={filterFieldsData?.message}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => setFilterFieldsData({ ...filterFieldsData, message: e.target.value })}
                />
              </div>
              <div className="col-sm-6">
                <FileUpload
                  id={"ff_attachment"}
                  accept=".pdf,.png,.jpg,.jpeg,.doc"
                  documentUploadUrl={documentUploadUrlPublic}
                  documentUrlData={documentUrlDataPublic}
                  onChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, attachment_file: val })
                  }
                  multiple={true}
                >
                  <span className="btn btn-transparent">
                    {localization.attachment}
                  </span>
                </FileUpload>
              </div>

              {source !== 'LeadX' && (
              <>
              <div className="col-sm-12">
                <Checkbox
                  label={localization.markAsClosed}
                  onChange={(val) => setFilterFieldsData({ ...filterFieldsData, isClosed: val })}
                  type="checkbox"
                  noWrap={true}
                  mtValue={true}
                />
              </div>
              {filterFieldsData.isClosed === true  &&
                <>
                  <div className='col-md-12 col-sm-12'>
                    <DropDownInput
                      data={viewDropdown?.issue_dropdown}
                      label={localization.issueRelatedTo}
                      required
                      errorMsg={localization.requiredName}
                      getIdValue={handleIssueRelatedToChange}
                      getValueById={filterFieldsData.issue_related_to}
                      isStarRequired={true}
                    />
                  </div>

                  {filterFieldsData.issue_related_to &&
                    getSubIssueDropdown?.data?.length > 0 && (
                    <div className='col-md-12 col-sm-12'>
                      <DropDownInput
                        key={filterFieldsData.issue_related_to}
                        data={getSubIssueDropdown.data}
                        label={'Sub Type'}
                        required
                        errorMsg={localization.requiredName}
                        getIdValue={(val) => {
                          if (!val?.id) return;
                          setFilterFieldsData({
                            ...filterFieldsData,
                            issue_related_to_sub_cat: val.id,
                          });
                        }}
                        getValueById={filterFieldsData.issue_related_to_sub_cat}
                        isStarRequired={true}
                      />
                    </div>
                  )}

                  <div className='col-md-12 col-sm-12'>
                    <TextAreaInput
                      name="body"
                      type="text"
                      rows={2}
                      className={`inline-css scrollbar-styling`}
                      label={localization.rca}
                      value={filterFieldsData?.rca}
                      inputValue={filterFieldsData?.rca}
                      required={true}
                      isStarRequired={true}
                      errorMsg={localization.isRequired}
                      handleChange={(e) => setFilterFieldsData({ ...filterFieldsData, rca: e.target.value })}
                    />
                  </div>
                </>
              }
              </>
              )}

              {filterFieldsData && filterFieldsData?.send_to == 'Client' ?
                <Checkbox
                  label={'Attachment Mandatory'}
                  onChange={(val) => setFilterFieldsData({ ...filterFieldsData, attachment_mand: val })}
                  type="checkbox"
                />
                :
                null
              }

              <hr />

              <div className="btn-wrapper">
                <button
                  disabled={false}
                  type="submit"
                  className="btn btn-primary "
                >
                  {`Submit`}
                  <img src={Images?.ArrowRight} alt="" />
                </button>
                <br />
                <br />
              </div>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default ComplaintReplySupport;
